import { BookOpen, Disc3, Drum, Ellipsis, Layers, type LucideIcon } from 'lucide-react';
import type { TabId } from '../data/types';

export interface TabDef {
  id: TabId;
  label: string;
  icon: LucideIcon;
  /** Where the tab opens when there's no remembered sub-view */
  home: string;
}

// SPEC §4: Dig · Drums · Beat · Learn · More
export const TABS: TabDef[] = [
  { id: 'dig', label: 'Dig', icon: Disc3, home: '/dig' },
  { id: 'drums', label: 'Drums', icon: Drum, home: '/drums/library' },
  { id: 'beat', label: 'Beat', icon: Layers, home: '/beat' },
  { id: 'learn', label: 'Learn', icon: BookOpen, home: '/learn' },
  { id: 'more', label: 'More', icon: Ellipsis, home: '/more' },
];

export function tabOf(pathname: string): TabId | undefined {
  const first = pathname.split('/')[1];
  return TABS.find((t) => t.id === first)?.id;
}
